<template>
	<div class="sliderScreeningPage visImage bigScreen" v-cloak>
		<div class="sliderScreening latticeBg visImageTop breadth fz14">
			<div>
				<span class="text marr8">时间</span>
				<div class="inlin sliderScreeningR">
					<el-date-picker 
					class="time sliderDataCls" 
					v-model="reportDate.data" 
					type="monthrange" 
					@change="datePicker"
					:picker-options="pickerOptions"
					unlink-panels range-separator="~" value-format="yyyy/MM" format='yyyy-MM' start-placeholder="开始时间"
					 end-placeholder="结束时间">
					</el-date-picker>
				</div>
			</div>
		</div>
		<div>
			<el-row>
				<el-col :span="4">
					<div class="latticeBg breadth statistics" v-loading="countLoading">
						<el-row>
							<vis-two-number-grow :hospitalCountList="numberHospital"></vis-two-number-grow>
							<div class="fz14 mart23 center">
								<span class="marr20 dodgerBlue underline cur"></span>
							</div>
						</el-row>
					</div>
					<vis-left-pie v-loading="pieLoading"
					class="latticeBg"
					:unqualifiedStatus="'false'"
					:tabType="tabsSwitchArr"
					:tableType="tableSwitchArr"
					:piestatus="'region'"
					></vis-left-pie>
				</el-col>
				<el-col :span="20" class="pdl10">
					<el-row class="latticeBg">
						<ul class="tabs pdt8">
							<li :class="tabsSwitchArr==2?'tabsActive':''" @click="tabsSwitch(2)">报告</li>
							<li :class="tabsSwitchArr==3?'tabsActive':''" @click="tabsSwitch(3)">影像</li>
						</ul>
					</el-row>
					<el-row class="supervisorPages">
						<el-col :span="16" class="pdr10">
							<vis-tradar-charts v-loading="tradarLoading"
							:percent="tabsSwitchArr==2?hospitalCountLists.MoreThanRate:hospitalCountLists.ImageMoreThanRate"
							:title="`${regionbreadcrumbList[1]}能力评估`"
							:suffix="'区域'"
							:colorList="['#30D9A0', '#2181FF']"
							:dataList="radarHospitalList"
							:icon="'visregion'"
							:legendData="['全国', regionbreadcrumbList[1]]"
							></vis-tradar-charts>
							<vis-portrait-line v-loading="portraitLoading" 
							class="latticeBg mart10 barSubpageHeight" 
							:icon="'iconvisunqualified'" 
							:title="`月度${titleText}平均分`" 
							:unit="'分'"
							:status="'region'"
							:chartsType="'line'"
							:unqualifiedStatus="'false'"
							tooltip="平均分"
							:tabType="tabsSwitchArr"
							:colorList="['#32DAA1','#3FE3AC','#2B5F53']" 
							@movescoreMonthlyList="movescoreMonthlyList" 
							:name="'movescoreMonthlyList'"
							:reportList="scoreMonthlyList" 
							:type="'score'"></vis-portrait-line>
						</el-col>
						<el-col :span="8" class="mart10">
							<vis-region-line v-loading="regionLoading"
							class="latticeBg regionbarBoxHeight" 
							:icon="'iconvisImageCenter'" 
							:title="regionbreadcrumbList[1]+'平均分'" 
							:chartsType="'bar'"
							:colorList="['#32DAA1','#3FE3AC','#2B5F53']" 
							@movescoreMonthlyList="movescoreMonthlyList" 
							:name="'movescoreMonthlyList'"
							:reportList="HospitalAVGScoreList" 
							:type="'score'"></vis-region-line>
							
							<vis-portrait-line v-loading="unqualifiedLoading"
							 class="latticeBg  mart10 barSubpageHeight" 
							:icon="'iconvisunqualified'" 
							:title="`月度不合格${titleText}`" 
							:unit="'份'"
							:status="'region'"
							:tooltip="`${titleText}数`"
							:unqualifiedStatus="'true'"
							:tabType="tabsSwitchArr"
							:chartsType="'bar'"
							:colorList="['#2181FF','#6BB1FF','#2B5F53']" 
							@moveunqualifiedMonthly="moveunqualifiedMonthly" 
							:name="'moveunqualifiedMonthly'"
							:reportList="unqualifiedMonthlyList" 
							:type="'unqualified'" 
							:image="'false'"></vis-portrait-line>
							
							<vis-table v-loading="tableLoading" class="latticeBg mart10 pd10 regionHeight" :icon="'iconvisline'" :title="tabsSwitchArr==2?'医生':'技师'" 
							:className="''"
							:unqualiHeader="'true'" 
							:unqualifiedStatus="'false'"
							:dataList="tabsSwitchArr==2||tabsSwitchArr==4?doctorsAvgScore.Doctors:technicianAvgScore.Doctors"
							:pageCount="getAvgScoreParameter.pageCount" 
							:pageIndex="getAvgScoreParameter.pageIndex" 
							@moveAvgScoreParameter="moveAvgScoreParameter"
							:name="'moveAvgScoreParameter'" 
							:type="valueTransferType"
							:total="tabsSwitchArr==2||tabsSwitchArr==4?doctorsAvgScore.TotalCount:technicianAvgScore.TotalCount">
								<div class="fz12 tableBtnList" v-if="tabsSwitchArr==2">
									<span :class="tableSwitchArr==2?'tableBtnActive':''" @click="tableSwitch(2)">审核医生</span>
									<span :class="tableSwitchArr==4?'tableBtnActive':''" @click="tableSwitch(4)">诊断医生</span>
								</div>
							</vis-table>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	// import axios from "axios";
	import visTwoNumberGrow from '../../components/visualization/visTwoNumberGrow'
	import visLeftPie from '../../components/visualization/visLeftPie'
	import visTradarCharts from '../../components/visualization/visTradarCharts'
	import visPortraitLine from '@/components/visualization/visPortraitLine'
	import visRegionLine from '@/components/visualization/visRegionLine'
	import visTable from '@/components/visualization/visTable'
	// import { mapState, mapActions, mapMutations} from 'vuex'
	export default {
		data() {
			return {
				pickerOptions: {
					shortcuts: [
						{
							text: '本月',
							onClick(picker) {
								picker.$emit('pick', [new Date(), new Date()]);
							}
						},
						{
							text: '今年至今',
							onClick(picker) {
								const end = new Date();
								const start = new Date(new Date().getFullYear(), 0);
								picker.$emit('pick', [start, end]);
							}
						},
						{
							text: '最近六个月',
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setMonth(start.getMonth() - 6);
								picker.$emit('pick', [start, end]);
							}
						}
					],
					onPick: obj => {
						this.pickerMinDate = new Date(obj.minDate).getTime();
					},
					disabledDate: time => {
						if (this.pickerMinDate) {
							const day1 = 365 * 24 * 3600 * 1000;
							let maxTime = this.pickerMinDate + day1;
							let minTime = this.pickerMinDate - day1;
							return time.getTime() > maxTime || time.getTime() < minTime || time.getTime() > Date.now() - 1 * 24 * 3600 * 1000;
						} else {
							return time.getTime() > Date.now() - 1 * 24 * 3600 * 1000;
						}
					}
				},
				numberHospital: [],
				tabsSwitchArr: 2,
				tableSwitchArr: 2,
				dateVal: [],
				valueTransferType:2,
				countLoading:false,
				pieLoading:false,
				tradarLoading:false,
				portraitLoading:false,
				regionLoading:false,
				unqualifiedLoading:false,
				tableLoading:false,
				titleText:'报告'
			}
		},

		components: {
			visTwoNumberGrow,
			visLeftPie,
			visTradarCharts,
			visPortraitLine,
			visTable,
			visRegionLine
		},
		computed: {
			...Vuex.mapState('breadcrumb', ['breadLists', 'loading']),
			...Vuex.mapState('visualization', ['hospitalCountLists', 'reportDate', 'qcedReportMonthlyList', 'scoreMonthlyList',
				'unqualifiedMonthlyList', 'doctorsAvgScore', 'setDateArr', 'technicianAvgScore',
				'getAvgScoreParameter','radarHospitalList','doctorQCTaskParameter','regionbreadcrumbList',
				'HospitalAVGScoreList','getCountParameter'
			]),
			...Vuex.mapState('supervisor', ['GetReportListArr']),
		},
		activated() {
			this.reportDate.data = this.setDateArr.data;
			this.tabsSwitchArr = 2;
			this.callFunction(this.reportDate.data, this.tabsSwitchArr);
			this.$nextTick(() => {
				let index = Number(this.breadLists.breadList.length);
				this.breadLists.breadList[index - 1].name = this.regionbreadcrumbList[1];
			})
		},
		methods: {
			...Vuex.mapMutations('breadcrumb', ['setLoading']),
			...Vuex.mapMutations('visualization', ['setreportDate']),
			...Vuex.mapActions('visualization', ['GetHospitalCount', 'GetHospitalRadar', 'GetQCedReportMonthly', 'GetScoreMonthly',
				'GetUnqualifiedReportMonthly', 'GetDoctorsAvgScore', 'GetSummary','GetHospitalAVGScore'
			]),
			setloadingList(flag) {
				this.countLoading = flag;
				this.pieLoading = flag;
				this.tradarLoading = flag;
				this.portraitLoading = flag;
				this.regionLoading = flag;
				this.unqualifiedLoading = flag;
				this.tableLoading = flag;
			},
			setPar(dateVal, type){
				let pageCount = document.body.clientWidth >= 1440 ? 5 : 4;
				
				this.getAvgScoreParameter.type = type;
				this.getAvgScoreParameter.pageCount = pageCount;
				this.getAvgScoreParameter.regionId = this.GetReportListArr.regionId;
				this.getAvgScoreParameter.startdt = dateVal[0];
				this.getAvgScoreParameter.enddt = dateVal[1];
				this.getAvgScoreParameter.hospitalGuid = '';
				
				this.getCountParameter.doctorName = '';
				this.getCountParameter.regionId = this.GetReportListArr.regionId;
			},
			callFunction(dateVal, type) {
				let _this = this;
				_this.dateVal = dateVal;
				let dateList = {
					startdt: dateVal[0],
					enddt: dateVal[1],
					hospitalGuid: '',
					regionId: _this.GetReportListArr.regionId
				}
				
				
				_this.setPar(dateVal, type);
				// _this.setLoading(true);
				_this.setloadingList(true);
				this.GetHospitalCount(dateList).then(res => {
					this.countLoading = false;
					_this.numberHospital = [{
						number: _this.hospitalCountLists.TotalHospitalCount,
						icon: 'iconfont iconvisImageCenter visNumber',
						name: '中心数量',
						color: '#3D73DD',
						bgColor: '#344467',
						unit: ''
					}, {
						number: _this.hospitalCountLists.TotalReportCount,
						icon: 'iconfont iconvisReport visNumber',
						name: '样本',
						color: '#796EEE',
						bgColor: '#3F3F69',
						unit: '份'
					}, {
						number: _this.hospitalCountLists.TotalTechnicianCount,
						icon: 'iconfont iconvisTechnician visNumber',
						name: '技师',
						color: '#30B4D9',
						bgColor: '#2A5464',
						unit: '人'
					}, {
						number: _this.hospitalCountLists.TotalDoctorCount,
						icon: 'iconfont iconvisDoctor visNumber',
						name: '医生',
						color: '#4AA8F1',
						bgColor: '#32506B',
						unit: '人'
					}, {
						number: _this.hospitalCountLists.TotalUnqualifiedCount,
						icon: 'iconfont iconvisunqualified visNumber',
						name: '不合格样本',
						color: '#9662FF',
						bgColor: '#493B6F',
						unit: '份',
						computingMethod:'不合格样本 = <60分报告+<60分影像'
					}, {
						number: _this.hospitalCountLists.UnqualifiedRate,
						icon: 'iconfont iconvisrate visNumber',
						name: '不合格率',
						color: '#30D9A0',
						bgColor: '#2A5F53',
						unit: '%',
						computingMethod:'不合格率 = (不合格报告+不合格影像)/(样本总数*2)'
					}];
				});
				_this.GetSummary(dateList).then(res => {
					this.pieLoading = false;
				});
				_this.GetHospitalRadar({
					type: type,
					hospitalGuid:'',
					startdt: dateVal[0],
					enddt: dateVal[1],
					regionId: dateList.regionId
				}).then(res => {
					this.tradarLoading = false;
				});
				_this.GetScoreMonthly({
					modalityType: '',
					bodyPart: '',
					scanType: '',
					startdt: dateVal[0],
					enddt: dateVal[1],
					regionId: dateList.regionId
				}).then(res => {
					this.portraitLoading = false;
				});
				_this.GetUnqualifiedReportMonthly({
					hospitalGuid:'',
					modalityType: '',
					bodyPart: '',
					scanType: '',
					startdt: dateVal[0],
					enddt: dateVal[1],
					regionId: dateList.regionId
				}).then(res => {
					this.unqualifiedLoading = false;
				});
				_this.GetDoctorsAvgScore().then(res => {
					this.tableLoading = false;
				});
				_this.GetHospitalAVGScore({
					startdt: dateVal[0],
					enddt: dateVal[1],
					type:type,
					regionId: dateList.regionId
				}).then(res => {
					this.regionLoading = false;
				});
				// axios.all([
				// 	_this.GetDoctorsAvgScore(),
				// ]).then(axios.spread(function() {
				// 	_this.setLoading(false);
				// }))
			},
			datePicker(val) {
				this.setreportDate(val);
				this.callFunction(val, this.tabsSwitchArr)
			},
			tabsSwitch(type) {
				this.tabsSwitchArr = type;
				this.titleText = type==2?'报告':'影像';
				this.valueTransferType = type;
				let regionId =  this.GetReportListArr.regionId;
				this.tradarLoading = true;
				this.unqualifiedLoading = true;
				this.tableLoading = true;
				this.regionLoading = true;
				this.portraitLoading = true;
				this.setPar(this.dateVal, type);
				this.GetHospitalRadar({
					type: type,
					hospitalGuid:'',
					startdt: this.dateVal[0],
					enddt: this.dateVal[1],
					regionId:regionId
				}).then(res => {
					this.tradarLoading = false;
				});
				this.GetUnqualifiedReportMonthly({
					hospitalGuid:'',
					modalityType: '',
					bodyPart: '',
					scanType: '',
					startdt: this.dateVal[0],
					enddt: this.dateVal[1],
					regionId:regionId
				}).then(res => {
					this.unqualifiedLoading = false;
				});
				this.GetDoctorsAvgScore().then(res => {
					this.tableLoading = false;
				});
				this.GetHospitalAVGScore({
					startdt: this.dateVal[0],
					enddt: this.dateVal[1],
					type:type,
					regionId:regionId
				}).then(res => {
					this.regionLoading = false;
				});
				this.GetScoreMonthly({
					type: type,
					modalityType: '',
					bodyPart: '',
					scanType: '',
					startdt: this.dateVal[0],
					enddt: this.dateVal[1],
					regionId: regionId
				}).then(res => {
					this.portraitLoading = false;
				});
			},
			moveAvgScoreParameter(val){
				this.getAvgScoreParameter.pageIndex = val;
				this.tableLoading = true;
				this.GetDoctorsAvgScore().then(res => {
					this.tableLoading = false;
				});
			},
			tableSwitch(val) {
				this.tableSwitchArr = val;
				this.valueTransferType = val;
				this.tableLoading = true;
				this.setPar(this.dateVal, val);
				this.GetDoctorsAvgScore().then(res => {
					this.tableLoading = false;
				});
			},
			resetParameter() {
				this.parameter = {
					modalityType: '',
					bodyPart: '',
					scanType: '',
					startdt: '',
					enddt: '',
					hospitalGuid: ''
				}
			},
			judgeParameter(item) {
				let _this = this;
				switch (item.type) {
					case 'all':
						_this.resetParameter();
						break;
					case 'modalityType':
						_this.resetParameter();
						_this.parameter.modalityType = item.name;
						break;
					case 'scanType':
						_this.resetParameter();
						_this.parameter.scanType = item.name;
						break;
					case 'bodypart':
						_this.resetParameter();
						_this.parameter.bodyPart = item.name;
						break;
					default:
						_this.resetParameter();
						break;
				}
				this.parameter.startdt = this.setDateArr.data[0];
				this.parameter.enddt = this.setDateArr.data[1];
				this.parameter.regionId = this.GetReportListArr.regionId;
				this.parameter.type = this.tabsSwitchArr;
			},
			movescoreMonthlyList(item) {
				this.judgeParameter(item);
				this.portraitLoading = true;
				this.GetScoreMonthly(this.parameter).then(res => {
					this.portraitLoading = false;
				});
			},
			moveunqualifiedMonthly(item) {
				this.judgeParameter(item);
				this.unqualifiedLoading = true;
				this.GetUnqualifiedReportMonthly(this.parameter).then(res => {
					this.unqualifiedLoading = false;
				});
			}
		}
	}
</script>

<style>
</style>
